"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5915],{

/***/ 5915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ArrowDownIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "11px",
        height: "7px",
        viewBox: "0 0 11.0 7.0",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "551181145550105570109114",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "111114112108119111984810754",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2388,0 C2391.86599,-7.10171439e-16 2395,3.13400675 2395,7 L2395,736 C2395,739.865993 2391.86599,743 2388,743 L7,743 C3.13400675,743 -5.63699712e-14,739.865993 0,736 L0,7 C-4.73447626e-16,3.13400675 3.13400675,-5.5070775e-15 7,0 L2388,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "4857551005510811710849112",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 L370,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "12210454122519510911510156",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M9.03252,0 L10.24,1.20744 L5.12,6.32744 L0,1.20744 L1.20748,0 L5.12,3.91252 L9.03252,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-601.0 -3295.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#551181145550105570109114)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(-233.0 2999.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#111114112108119111984810754)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "233,0 2153,0 2153,743 233,743 233,0",
                                    stroke: "none",
                                    fill: "#EFF5F7"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(270.0 3076.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#4857551005510811710849112)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 374,0 374,609 0,609 0,0",
                                        stroke: "none",
                                        fill: "#FFFFFF"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4,0 L370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 Z",
                                        stroke: "#F9F9F9",
                                        strokeWidth: "6",
                                        fill: "none",
                                        strokeMiterlimit: "5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(601.0 3295.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                transform: "translate(0.0 0.036279999999999646)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    clipPath: "url(#12210454122519510911510156)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 10.24,0 10.24,6.32744 0,6.32744 0,0",
                                        stroke: "none",
                                        fill: "#939495"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArrowDownIcon);


/***/ })

}]);